import React, { useState, useEffect } from "react";
import CustomToast from "../../components/CustomToast.js";
import CustomTable from "../../components/CustomTable/CustomTable.js";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import { exportForm, searchForms } from "../../utils/api/store";
import moment from "moment";
import CustomMap from "../../components/CustomMap/CustomMap";
import { Col, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";

function Consumers({ setInactive }) {
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [data, setData] = useState([]);
  const [mapUrls, setMapUrls] = useState([]);
  const [searchData, setSearchData] = useState({
    encodedBy: "",
    dateTo: new Date(),
    dateFrom: new Date(),
  });
  const [show, setShow] = useState(false);
  const [exportable, setExportable] = useState({ items: [], headers: [] });
  const [backdrop, setBackdrop] = useState(true);
  const [mapData, setMapData] = useState({
    lat: 0,
    lng: 0,
    address: "",
    store_name: "",
    photo: "",
  });
  const [signatureURL, setSignatureURL] = useState("");
  const [showSignature, setShowSignature] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(0);

  const headers = [
    "Date",
    "Encoded By",
    "Encoded On",
    "Classification Type",
    "Activation Type",
    "APS Name",
    "Store/Venue",
    "Competitor's Activity",
    "Address 1",
    "Address 2",
    "Long/Lat 1",
    "Long/Lat 2",
    "Photo",
    "Customer Name",
    "Customer Phone Number",
    "Customer Email/FB Account",
    "Load Only",
    "Acts + Loads",
    "Device",
    "Best Time to Call",
    //"OR Number",
    // "Diabetasol Diagnosis",
    // "Entrasol Diagnosis",
    // "Diabetasol Sweetener Diagnosis",
    //"Best Time to Call",
    // "BUMO",
    // "LC/NP/PTS",
    // "EU/CG",
  ];

  const handleShow = (long, lat, address, store_name, photo) => {
    setMapData({
      lat: lat,
      lng: long,
      address: address,
      store_name: store_name,
      photo: photo,
    });
    setInactive(false);
    setShow(true);
  };

  const handleShowSignature = (url) => {
    setSignatureURL(url);
    setShowSignature(true);
  };

  const handleSearch = async () => {
    setMapUrls([]);
    const response = await searchForms(
      searchData.dateFrom,
      searchData.dateTo,
      searchData.encodedBy,
      "consumer",
      page
    );

    if (response?.data?.data) {
      setSize(response.data.size);
      let dataToDisplay = [];
      let exportableData = [];
      let extractedMapUrls = [];

      response.data.data.forEach((item) => {
        let row = [];
        let exportableTemp = [];

        const store_date = item.date ? moment(item.date).format("MMMM Do YYYY") : "";
        row.push(store_date);
        exportableTemp.push(store_date);

        const encoded_by = item.encoded_by || "";
        row.push(encoded_by);
        exportableTemp.push(encoded_by);

        const added_on = item.encoded_on ? moment(item.encoded_on).format("MMMM Do YYYY, h:mm a") : "";
        row.push(added_on);
        exportableTemp.push(added_on);

        row.push(item.classification_type || "");
        exportableTemp.push(item.classification_type || "");

        row.push(item.activation_type || "");
        exportableTemp.push(item.activation_type || "");

        row.push(item.anc_ans_aps || "");
        exportableTemp.push(item.anc_ans_aps || "");

        row.push(item.store_venue || "");
        exportableTemp.push(item.store_venue || "");

        row.push(item.competitors_activity || "");
        exportableTemp.push(item.competitors_activity || "");

        row.push(item.address1 || "");
        exportableTemp.push(item.address1 || "");

        row.push(item.address2 || "");
        exportableTemp.push(item.address2 || "");

        row.push(item.long_lat_1 || "");
        exportableTemp.push(item.long_lat_1 || "");

        row.push(item.long_lat_2 || "");
        exportableTemp.push(item.long_lat_2 || "");

        const photo = item.photo ? item.photo.toString() : null;
        const mapUrl =
          window.location.origin +
          "/public_map?lat=" +
          (item.long_lat_1 ? item.long_lat_1.split("/")[1] : "") +
          "&lng=" +
          (item.long_lat_1 ? item.long_lat_1.split("/")[0] : "") +
          "&address=" +
          (item.address1 || "") +
          "&store_name=" +
          (item.store_venue || "") +
          "&photo=" +
          photo;

        extractedMapUrls.push(mapUrl);

        if (photo) {
          row.push(
            <button
              onClick={() =>
                handleShow(
                  item.long_lat_1 ? item.long_lat_1.split("/")[0] : "",
                  item.long_lat_1 ? item.long_lat_1.split("/")[1] : "",
                  item.address1,
                  item.store_venue,
                  photo
                )
              }
            >
              View
            </button>
          );
          exportableTemp.push(mapUrl);
        } else {
          row.push(item.reason_image || "");
          exportableTemp.push(item.reason_image || "");
        }

        row.push(item.customer_name || "");
        exportableTemp.push(item.customer_name || "");

        row.push(item.contact_no || "");
        exportableTemp.push(item.contact_no || "");

        row.push(item.email || "");
        exportableTemp.push(item.email || "");

        row.push(item.is_diabetasol === "1" ? "✓" : "");
        exportableTemp.push(item.is_diabetasol === "1" ? "✓" : "");

        row.push(item.is_entrasol === "1" ? "✓" : "");
        exportableTemp.push(item.is_entrasol === "1" ? "✓" : "");

        row.push(item.is_diabetasol_sweetener === "1" ? "✓" : "");
        exportableTemp.push(item.is_diabetasol_sweetener === "1" ? "✓" : "");

        row.push(item.call_time || "");
        exportableTemp.push(item.call_time || "");

        // row.push(item.bumo || "");
        // exportableTemp.push(item.bumo || "");

        // row.push(item.lc_nc_p || "");
        // exportableTemp.push(item.lc_nc_p || "");

        // row.push(item.eu_cg || "");
        // exportableTemp.push(item.eu_cg || "");

        dataToDisplay.push(row);
        exportableData.push(exportableTemp);
      });

      setMapUrls(extractedMapUrls);
      setExportable({ items: exportableData, headers: headers });
      setData(dataToDisplay);
    } else {
      setMessage({
        message: response?.data?.messages?.error || "Something went wrong.",
        type: "danger",
      });
      setShowToast(true);
    }
  };

  const handlePaginateSearch = async (selectedPage) => {
    const pageNumber = selectedPage.selected + 1;
    setPage(pageNumber);
    handleSearch();
  };

  const handleExport = async () => {
    const response = await exportForm(
      searchData.dateFrom,
      searchData.dateTo,
      searchData.encodedBy,
      "consumer"
    );
    if (response.data?.url) {
      window.open(response.data.url, "_blank");
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="container-fluid" style={{ paddingTop: "170px" }}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: "250px",
          right: 0,
          zIndex: 99,
          backgroundColor: "#fff",
          padding: "12px 16px 8px 16px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
        }}
      >
        <div className="row text-center">
          <div className="col-md-12">
            <p className="h1 title">CONSUMERS</p>
          </div>
        </div>

        <div className="row align-items-center mb-2 mt-3">
          <div className="col-12 col-sm-5">
            <InputGroup>
              <Form.Control
                placeholder="Search by Encoded By"
                value={searchData.encodedBy}
                onChange={(e) =>
                  setSearchData({ ...searchData, encodedBy: e.target.value })
                }
              />
            </InputGroup>
          </div>

          <div className="col-12 col-sm-2">
            <DatePicker
              selected={searchData.dateFrom}
              onChange={(date) => setSearchData({ ...searchData, dateFrom: date })}
              className="form-control"
            />
          </div>

          <div className="col-12 col-sm-2">
            <DatePicker
              selected={searchData.dateTo}
              onChange={(date) => setSearchData({ ...searchData, dateTo: date })}
              className="form-control"
            />
          </div>

          <div className="col-12 col-sm-3">
            <Button variant="primary" className="w-100" onClick={handleSearch}>
              Search
            </Button>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-start mb-3 mt-5">
        <Button variant="success" onClick={handleExport}>
          Export Excel
        </Button>
      </div>

      <div className="row justify-content-center">
        <CustomTable
          size={size}
          items={data}
          mapUrls={mapUrls}
          setItems={setData}
          headers={headers}
          itemsPerPage={10}
          title="Consumers"
          exportable={exportable}
          photoIndex={12}
          beginningIndex={0}
          endIndex={10}
          handleExport={handleExport}
          type="form-report"
          setPage={setPage}
        />
      </div>

      <div className="row justify-content-center mt-3">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(size / 10)}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          containerClassName="pagination justify-content-center"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          activeClassName="active"
          onPageChange={handlePaginateSearch}
        />
      </div>

      <CustomToast
        type={details.type}
        message={details.message}
        title="Consumers"
        show={showToast}
        setShow={setShowToast}
      />

      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        className="p-0"
        style={{ zIndex: backdrop ? 99999 : 0 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Store Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomMap mapData={mapData} setBackdrop={setBackdrop} />
        </Modal.Body>
      </Modal>

      <Modal
        show={showSignature}
        onHide={() => setShowSignature(false)}
        centered
        className="p-0"
        style={{ zIndex: backdrop ? 99999 : 0 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Signature Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col style={{ display: "flex", justifyContent: "center" }}>
              <img src={signatureURL} alt="Signature" style={{ maxWidth: "100%" }} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Consumers;